import React from 'react'

const Input = ({ label, htmlFor, name, value, type, placeholder="", required, icon, onChange, className, accept, loader, autoComplete, ...props }) => {

    return (
        <div className={"form-group " + className}>
            <label htmlFor={htmlFor}>{label}</label>
            <input value={value} onChange={onChange} type={type} name={name}
                placeholder={`${placeholder} ${required ? '*' : ''}`} {...props} htmlFor />
            <span>
                {icon}
            </span>
        </div>
    )
}
export default Input;
